import { render, staticRenderFns } from "./LpuSpecialityListDialog.vue?vue&type=template&id=4f7486fc&"
import script from "./LpuSpecialityListDialog.vue?vue&type=script&lang=js&"
export * from "./LpuSpecialityListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f7486fc')) {
      api.createRecord('4f7486fc', component.options)
    } else {
      api.reload('4f7486fc', component.options)
    }
    module.hot.accept("./LpuSpecialityListDialog.vue?vue&type=template&id=4f7486fc&", function () {
      api.rerender('4f7486fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/LpuSpecialityList/components/common/LpuSpecialityListDialog.vue"
export default component.exports